import {Route} from '@angular/router';
import {HomeComponent} from './home.component';

export const homeRoutes: Array<Route> = [
    {path: '', component: HomeComponent}
];
